"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.testRequiredFromHost = exports.reportBadCommand2 = exports.reportBadCommand = exports.getGameList_test = exports.getGameList = exports.refreshGameList = exports._sendMessageWorldState = exports._sendMessageAndImmediatelyExecute_nonHost = exports._sendMessageAndImmediatelyExecute = exports._sendMessageToHost = exports._sendMessageToAll = exports._sendMessageToOthers = exports._sendMessageRequest = exports.sendMessageAndImmediatelyExecute_nonHost = exports.hostChannel = exports.leaveChannel = exports.joinChannel = exports.update = exports.tryConnect = exports.create = exports.isStillConnecting = exports.getConnectionStatus = exports.getIsHost = exports.getPingTime = exports.setMultiName = exports.getMultiName = exports.setGameSyncNumber = exports.getGameSyncNumber = exports.getChannel = exports.getHostId = exports.getMultiId = exports.getIsSingleplayer = exports.setSingleplayer = exports.setSkipVersionCheck = exports.setMultiplayerAutoJoin = exports.getMultiplayerAutoJoin = exports.setUseRemoteMultiplayer = exports.getUseRemoteMultiplayer = void 0;
var assert_sidecar_1 = require("../lib/assert-sidecar");
var queryString_sidecar_1 = require("../lib/queryString-sidecar");
var rando_sidecar_1 = require("../lib/rando-sidecar");
var messageWriter_sidecar_1 = require("./messageWriter-sidecar");
var settings_sidecar_1 = require("./settings-sidecar");
var _extensions = null;
function setExtensions(ex) {
    _extensions = ex;
}
var namespace = 'ws:// ';
var watchdogHeartbeatInterval = 5000;
var verboseIncoming = false;
var verboseOutgoing = false;
var verboseHeartbeat = false;
var _useRemoteMultiplayer = true;
function getUseRemoteMultiplayer() {
    return _useRemoteMultiplayer;
}
exports.getUseRemoteMultiplayer = getUseRemoteMultiplayer;
function setUseRemoteMultiplayer(v) {
    _useRemoteMultiplayer = v;
}
exports.setUseRemoteMultiplayer = setUseRemoteMultiplayer;
var _multiplayerAutoJoin = false;
function getMultiplayerAutoJoin() {
    return _multiplayerAutoJoin;
}
exports.getMultiplayerAutoJoin = getMultiplayerAutoJoin;
function setMultiplayerAutoJoin(v) {
    _multiplayerAutoJoin = v;
}
exports.setMultiplayerAutoJoin = setMultiplayerAutoJoin;
var _skipVersionCheck = false;
function setSkipVersionCheck(skip) {
    _skipVersionCheck = skip;
}
exports.setSkipVersionCheck = setSkipVersionCheck;
var _outBuffer = [];
var _inBuffer = [];
// const _selfSendBuffer: IOutBuffer[] = []
var _isSingleplayer = false;
function setSingleplayer(isSingleplayer) {
    _isSingleplayer = isSingleplayer;
}
exports.setSingleplayer = setSingleplayer;
function getIsSingleplayer() {
    return _isSingleplayer;
}
exports.getIsSingleplayer = getIsSingleplayer;
var _multiId = -1;
function getMultiId() {
    return _multiId;
}
exports.getMultiId = getMultiId;
var _hostId = -1;
function getHostId() {
    if (_isSingleplayer) {
        return getMultiId();
    }
    return _hostId;
}
exports.getHostId = getHostId;
var _channel = '-';
function getChannel() {
    return _channel;
}
exports.getChannel = getChannel;
// TODO: just move this to our simulation manager?
var _gameSyncNumber = 0;
function getGameSyncNumber() {
    return _gameSyncNumber;
}
exports.getGameSyncNumber = getGameSyncNumber;
function setGameSyncNumber(sync) {
    _gameSyncNumber = sync;
}
exports.setGameSyncNumber = setGameSyncNumber;
// let _simulationFrame = 0
// export function getSimulationFrame() {
//   return _simulationFrame
// }
// export function setSimulationFrame(frame: number) {
//   _simulationFrame = frame
// }
// let _multiName = 'anon'
function getMultiName() {
    var playerNameOverride = queryString_sidecar_1.queryString.getByName('name') || '';
    playerNameOverride.trim();
    if (playerNameOverride) {
        return playerNameOverride.trim();
    }
    return settings_sidecar_1.settings.get().multiplayerName;
}
exports.getMultiName = getMultiName;
function setMultiName(name) {
    settings_sidecar_1.settings.update({ multiplayerName: name });
    sendToAll('setname|' + name);
    // _multiName = name
}
exports.setMultiName = setMultiName;
var _pingTime = 999;
function getPingTime() {
    return _pingTime;
}
exports.getPingTime = getPingTime;
var _isHost = false;
function getIsHost() {
    return _isHost || _isSingleplayer;
}
exports.getIsHost = getIsHost;
function getConnectionStatus() {
    if (!_ws) {
        return 'D/C';
    }
    if (_ws.readyState === WebSocket.CONNECTING) {
        return 'Connecting...';
    }
    if (_ws.readyState === WebSocket.OPEN) {
        return 'Open';
    }
    if (_ws.readyState === WebSocket.CLOSING) {
        return 'Closing...';
    }
    if (_ws.readyState === WebSocket.CLOSED) {
        return 'Closed';
    }
    return '?' + _ws.readyState;
}
exports.getConnectionStatus = getConnectionStatus;
function isStillConnecting() {
    return !_ws || _ws.readyState === WebSocket.CONNECTING;
}
exports.isStillConnecting = isStillConnecting;
var _ws = null;
var _version = '';
var _serverVersion = '';
var _hasInvalidVersion = false;
function create(ex, version) {
    _version = version;
    setExtensions(ex);
}
exports.create = create;
function tryConnect() {
    assert_sidecar_1.assert.notNil(_extensions);
    var address = _extensions.extension_getLocalServerAddress();
    if (_useRemoteMultiplayer) {
        address = _extensions.extension_getRemoteServerAddress();
    }
    console.log(namespace, 'try connect to', address);
    _ws = new WebSocket(address);
    _ws.binaryType = 'arraybuffer';
    // console.log('ws', ws)
    var _pingWatchdogTimeout = 0;
    function heartbeat() {
        // Use `WebSocket#terminate()`, which immediately destroys the connection,
        // instead of `WebSocket#close()`, which waits for the close timer.
        // Delay should be equal to the interval at which your server
        // sends out pings plus a conservative assumption of the latency.
        if (verboseHeartbeat) {
            console.log(namespace, 'heartbeat');
        }
        if (_pingWatchdogTimeout) {
            clearTimeout(_pingWatchdogTimeout);
        }
        _pingWatchdogTimeout = setTimeout(function () {
            console.log(namespace, 'heartbeat failed');
            assert_sidecar_1.assert.notNil(_ws);
            _ws.close();
        }, watchdogHeartbeatInterval + 5000);
    }
    _ws.onopen = function (ev) {
        console.log(namespace, 'connected');
        assert_sidecar_1.assert.notNil(_ws);
        // ws.socketData = createSocketData()
        // _ws.send('now is: ' + Date.now())
        heartbeat();
        var tryChan = queryString_sidecar_1.queryString.getByName('chan') || '';
        var tryIsHost = queryString_sidecar_1.queryString.getByName('host') != null;
        var tryIsClient = queryString_sidecar_1.queryString.getByName('client') != null;
        console.log(namespace, tryChan, tryIsHost);
        if (_multiplayerAutoJoin) {
            if (tryChan) {
                //_isHost = isHost
                if (!tryIsHost) {
                    // Join after host, hopefully
                    setTimeout(function () {
                        joinChannel(tryChan, tryIsHost, tryIsClient, '');
                    }, 1000);
                }
                else {
                    joinChannel(tryChan, tryIsHost, tryIsClient, '');
                }
            }
        }
    };
    _ws.onmessage = function (ev) {
        assert_sidecar_1.assert.notNil(_ws);
        if (ev.data instanceof ArrayBuffer) {
            _inBuffer.push({
                stringMessage: '',
                buffer: ev.data,
            });
        }
        else {
            var sm = '' + ev.data;
            if (sm.startsWith('ping|')) {
                // Handle heartbeat right away
                heartbeat();
                _ws.send('pong');
            }
            _inBuffer.push({
                stringMessage: sm,
                buffer: null,
            });
        }
    };
    _ws.onclose = function () {
        console.log(namespace, 'disconnected');
        clearTimeout(_pingWatchdogTimeout);
        if (!_hasInvalidVersion) {
            setTimeout(function () {
                tryConnect();
            }, 2000);
        }
    };
}
exports.tryConnect = tryConnect;
function update() {
    assert_sidecar_1.assert.notNil(_extensions);
    _extensions.extension_onUpdate();
    // while (_selfSendBuffer.length > 0) {
    //   let msg = _selfSendBuffer.shift()
    //   if (msg) {
    //     onMessage(msg.stringMessage, msg.mw?.buffer || null)
    //   }
    // }
    while (_inBuffer.length > 0) {
        var msg = _inBuffer.shift();
        if (msg) {
            onMessage(msg.stringMessage, msg.buffer);
        }
    }
    while (_outBuffer.length > 0) {
        var msg = _outBuffer.shift();
        // TODO: check who should get the message
        // TODO: send special messages to self (add directly to in buffer)
        if (msg) {
            if (_isSingleplayer || (_ws === null || _ws === void 0 ? void 0 : _ws.readyState) === WebSocket.OPEN) {
                if (msg.stringMessage) {
                    if (verboseOutgoing) {
                        console.log(namespace, 'S=>', msg.stringMessage);
                    }
                    if (_isSingleplayer) {
                        _inBuffer.push({
                            stringMessage: msg.stringMessage,
                            buffer: null,
                        });
                    }
                    else {
                        assert_sidecar_1.assert.notNil(_ws);
                        _ws.send(msg.stringMessage);
                    }
                }
                else if (msg.mw) {
                    if (verboseOutgoing) {
                        console.log(namespace, 'B=>', msg);
                    }
                    var arrayBuffer = msg.mw.buffer.slice(0, msg.mw.offset);
                    if (_isSingleplayer) {
                        _inBuffer.push({
                            stringMessage: '',
                            buffer: arrayBuffer,
                        });
                    }
                    else {
                        assert_sidecar_1.assert.notNil(_ws);
                        _ws.send(arrayBuffer);
                    }
                }
            }
        }
    }
}
exports.update = update;
function onMessage(stringMessage, dataBuffer) {
    if (dataBuffer) {
        if (verboseIncoming) {
            console.log(namespace, '<=B', dataBuffer);
            console.log('got array buffer', dataBuffer);
        }
        var m = messageWriter_sidecar_1.messageWriter.create(false, dataBuffer);
        assert_sidecar_1.assert.notNil(_extensions);
        _extensions.extension_process(m, false);
    }
    else {
        var args = stringMessage.split('|', 50);
        // console.log(namespace, '<=S', sm)
        if (verboseIncoming) {
            console.log(namespace, '<=S', stringMessage);
            console.log(namespace, 'args', args[0], args[1], args[2]);
        }
        if (args[0] === 'ping') {
            _pingTime = parseInt(args[1]);
            if (verboseIncoming) {
                console.log(namespace, 'my ping is', _pingTime);
            }
        }
        if (args[0] === 'list') {
            var numPlayers = parseInt(args[1]);
            var key = args[2];
            var hasPassword = args[3] === 'p';
            _gameList.push({ key: key, numPlayers: numPlayers, hasPassword: hasPassword });
        }
        if (args[0] === 'welcome') {
            _serverVersion = args[1];
            _multiId = parseInt(args[2]);
            if (verboseIncoming) {
                // console.log(namespace, 'i am welcomed as', _serverVersion, _multiId)
            }
            console.log(namespace, 'i am welcomed as', _serverVersion, _multiId, stringMessage);
            console.log(namespace, 'checking version', _serverVersion, _version);
            if (_serverVersion !== _version) {
                console.warn(namespace, 'invalid version!');
                if (!_skipVersionCheck) {
                    _hasInvalidVersion = true;
                    if (_ws) {
                        _ws.close();
                    }
                    assert_sidecar_1.assert.notNil(_extensions);
                    _extensions.extension_onVersionFail(_serverVersion, _version);
                }
            }
        }
        if (args[0] === 'server-error') {
            _extensions === null || _extensions === void 0 ? void 0 : _extensions.extension_onServerError();
        }
        if (args[0] === 'wrong-password') {
            _extensions === null || _extensions === void 0 ? void 0 : _extensions.extension_onPasswordWrong();
        }
        if (args[0] === 'no-channel') {
            _extensions === null || _extensions === void 0 ? void 0 : _extensions.extension_onNoChannel();
        }
        if (args[0] === 'you-joined') {
            var clientOrHost = args[1];
            _channel = args[2];
            var _sHostId = args[3];
            var forceHost = queryString_sidecar_1.queryString.getByName('host') != null;
            _isHost = clientOrHost === 'host' || forceHost;
            _hostId = parseInt(_sHostId);
            console.log(namespace, 'i joined channel', _channel, clientOrHost, _sHostId);
            assert_sidecar_1.assert.notNil(_extensions);
            _extensions.extension_onMeJoin();
        }
        if (args[0] === 'chan') {
            if (args[1] === 'joined') {
                var multiId = parseInt(args[2], 10);
                var name_1 = args[3];
                if (verboseIncoming) {
                    console.log(namespace, 'report joined!', multiId, name_1);
                }
                assert_sidecar_1.assert.notNil(_extensions);
                _extensions.extension_onOtherJoin(multiId, name_1);
                if (getIsHost()) {
                    _extensions.extension_sendWorldState(multiId);
                }
            }
            if (args[1] === 'left') {
                var multiId = parseInt(args[2], 10);
                console.log(namespace, 'other left channel', multiId);
                if (verboseIncoming) {
                    console.log(namespace, 'report left!', multiId);
                }
                assert_sidecar_1.assert.notNil(_extensions);
                _extensions.extension_onOtherLeave(multiId);
                if (multiId === getHostId()) {
                    // Host left!
                    _extensions.extension_onHostLeft();
                    _onLeaveChannel();
                }
            }
        }
    }
}
function joinChannel(channelName, isHost, isClient, password) {
    console.log(namespace, 'attempting join channel', channelName);
    setSingleplayer(false);
    sendToAll('setname|' + getMultiName());
    var mode = 'any';
    if (isHost) {
        mode = 'host';
    }
    if (isClient) {
        mode = 'client';
    }
    sendToAll('join|' + channelName + '|' + mode + '|' + password);
}
exports.joinChannel = joinChannel;
function leaveChannel() {
    sendToAll('leave');
    _onLeaveChannel();
    console.log(namespace, 'left channel');
}
exports.leaveChannel = leaveChannel;
function _onLeaveChannel() {
    _channel = '-';
    setSingleplayer(false);
}
function hostChannel(password) {
    setSingleplayer(false);
    sendToAll('setname|' + getMultiName());
    sendToAll('host|' + password);
}
exports.hostChannel = hostChannel;
var _ignoreSinglePlayer = false;
function sendToAll(message) {
    if (_ignoreSinglePlayer && _isSingleplayer) {
        return;
    }
    _outBuffer.push({
        stringMessage: message,
        mw: null,
        toMultiId: 0,
    });
}
function sendMessageToAll(m, force) {
    if (force === void 0) { force = false; }
    if (_ignoreSinglePlayer && _isSingleplayer && !force) {
        return;
    }
    _outBuffer.push({
        stringMessage: '',
        mw: m,
        toMultiId: 0,
    });
    if (getIsHost() && !_isSingleplayer) {
        _inBuffer.push({
            stringMessage: '',
            buffer: m.buffer || null,
        });
    }
}
function sendMessageToHost(m, force) {
    if (force === void 0) { force = false; }
    if (_ignoreSinglePlayer && _isSingleplayer && !force) {
        return;
    }
    _outBuffer.push({
        stringMessage: '',
        mw: m,
        toMultiId: getHostId(),
    });
    if (getIsHost() && !_isSingleplayer) {
        _inBuffer.push({
            stringMessage: '',
            buffer: m.buffer || null,
        });
    }
}
function sendMessageToOne(m, multiId) {
    if (_ignoreSinglePlayer && _isSingleplayer) {
        return;
    }
    _outBuffer.push({
        stringMessage: '',
        mw: m,
        toMultiId: multiId,
    });
}
function sendMessageRequest(m) {
    if ((_ignoreSinglePlayer && _isSingleplayer) || getIsHost()) {
        messageWriter_sidecar_1.messageWriter.rewind(m);
        messageWriter_sidecar_1.messageWriter.read16(m);
        assert_sidecar_1.assert.notNil(_extensions);
        _extensions.extension_process(m, true);
    }
    else {
        sendMessageToAll(m);
    }
}
// This also sends to everyone (refactor this)
function sendMessageToOthers(m) {
    if (_ignoreSinglePlayer && _isSingleplayer) {
    }
    else {
        sendMessageToAll(m);
    }
}
function sendMessageAndImmediatelyExecute(m) {
    if (!getIsHost()) {
        // debugger
        console.error('trying to send and execute message but not host');
        messageWriter_sidecar_1.messageWriter.rewind(m);
        var a = messageWriter_sidecar_1.messageWriter.read8(m);
        var b = messageWriter_sidecar_1.messageWriter.read8(m);
        var c = messageWriter_sidecar_1.messageWriter.read8(m);
        console.error('trying to send and execute message but not host', a, b, c);
        return;
    }
    sendMessageToAll(m);
    messageWriter_sidecar_1.messageWriter.rewind(m);
    messageWriter_sidecar_1.messageWriter.read16(m);
    assert_sidecar_1.assert.notNil(_extensions);
    _extensions.extension_process(m, true);
}
function sendMessageAndImmediatelyExecute_nonHost(m) {
    sendMessageToAll(m);
    messageWriter_sidecar_1.messageWriter.rewind(m);
    messageWriter_sidecar_1.messageWriter.read16(m);
    assert_sidecar_1.assert.notNil(_extensions);
    _extensions.extension_process(m, true);
}
exports.sendMessageAndImmediatelyExecute_nonHost = sendMessageAndImmediatelyExecute_nonHost;
function _sendMessageRequest(write, msg) {
    var m = messageWriter_sidecar_1.messageWriter.create(); // TODO: send to host id
    messageWriter_sidecar_1.messageWriter.writeHeader(m, 0);
    write(m, msg);
    sendMessageRequest(m);
}
exports._sendMessageRequest = _sendMessageRequest;
function _sendMessageToOthers(write, msg) {
    var m = messageWriter_sidecar_1.messageWriter.create();
    messageWriter_sidecar_1.messageWriter.writeHeader(m, 0);
    write(m, msg);
    sendMessageToOthers(m);
}
exports._sendMessageToOthers = _sendMessageToOthers;
function _sendMessageToAll(write, msg, force, bufferSize) {
    if (bufferSize === void 0) { bufferSize = 1024; }
    var m = messageWriter_sidecar_1.messageWriter.create(false, null, bufferSize);
    messageWriter_sidecar_1.messageWriter.writeHeader(m, 0);
    write(m, msg);
    sendMessageToAll(m, force);
}
exports._sendMessageToAll = _sendMessageToAll;
function _sendMessageToHost(write, msg, force, bufferSize) {
    if (bufferSize === void 0) { bufferSize = 1024; }
    var m = messageWriter_sidecar_1.messageWriter.create(false, null, bufferSize);
    messageWriter_sidecar_1.messageWriter.writeHeader(m, 0);
    write(m, msg);
    sendMessageToHost(m, force);
}
exports._sendMessageToHost = _sendMessageToHost;
function _sendMessageAndImmediatelyExecute(write, msg) {
    var m = messageWriter_sidecar_1.messageWriter.create();
    messageWriter_sidecar_1.messageWriter.writeHeader(m, 0);
    write(m, msg);
    sendMessageAndImmediatelyExecute(m);
}
exports._sendMessageAndImmediatelyExecute = _sendMessageAndImmediatelyExecute;
function _sendMessageAndImmediatelyExecute_nonHost(write, msg) {
    var m = messageWriter_sidecar_1.messageWriter.create();
    messageWriter_sidecar_1.messageWriter.writeHeader(m, 0);
    write(m, msg);
    sendMessageAndImmediatelyExecute_nonHost(m);
}
exports._sendMessageAndImmediatelyExecute_nonHost = _sendMessageAndImmediatelyExecute_nonHost;
function _sendMessageWorldState(write, msg, multiId) {
    var m = messageWriter_sidecar_1.messageWriter.create();
    messageWriter_sidecar_1.messageWriter.writeHeader(m, multiId);
    write(m, msg);
    sendMessageToOne(m, multiId);
    // console.log('writing world state', multiId)
}
exports._sendMessageWorldState = _sendMessageWorldState;
var _gameList = [];
function refreshGameList() {
    _gameList = [];
    sendToAll('list|');
}
exports.refreshGameList = refreshGameList;
function getGameList() {
    // return getGameList_test()
    return _gameList;
}
exports.getGameList = getGameList;
function getGameList_test() {
    var testGames = [];
    for (var i = 0; i < 100; i++) {
        testGames.push({
            key: 'XYZ-' + rando_sidecar_1.rando.i(100, 999),
            numPlayers: rando_sidecar_1.rando.i(1, 3),
            hasPassword: rando_sidecar_1.rando.b(),
        });
    }
    return testGames;
}
exports.getGameList_test = getGameList_test;
function reportBadCommand(m, msg) {
    var error = [];
    for (var _i = 2; _i < arguments.length; _i++) {
        error[_i - 2] = arguments[_i];
    }
    console.error.apply(console, __spreadArray(['invalid message!'], __read(error)));
}
exports.reportBadCommand = reportBadCommand;
function reportBadCommand2(msg) {
    var error = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        error[_i - 1] = arguments[_i];
    }
    console.error.apply(console, __spreadArray(['invalid message!'], __read(error)));
}
exports.reportBadCommand2 = reportBadCommand2;
function testRequiredFromHost(isFromHost, m, msgId) {
    var error = [];
    for (var _i = 3; _i < arguments.length; _i++) {
        error[_i - 3] = arguments[_i];
    }
    if (!isFromHost) {
        console.error.apply(console, __spreadArray(['message not from host!', msgId], __read(error)));
    }
    return !isFromHost;
}
exports.testRequiredFromHost = testRequiredFromHost;
